import data from "./dataReducer"
import user from "./userReducer"

// eslint-disable-next-line import/no-anonymous-default-export
export default { user, data }
